import { render } from "./TransformerTab.vue?vue&type=template&id=6b8305de&scoped=true"
import script from "./TransformerTab.vue?vue&type=script&lang=js"
export * from "./TransformerTab.vue?vue&type=script&lang=js"

import "./TransformerTab.vue?vue&type=style&index=0&id=6b8305de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8305de"]])

export default __exports__